export default "__VITE_ASSET__DQpO4n2z__"